<template>
  <!-- 车辆出入场信息 -->
  <div class="page-container">
    <div class="back-content" style="padding-top: 15px;">
      <el-page-header @back="getReturn" content="车辆出入信息"> </el-page-header>
    </div>
    <el-divider></el-divider>
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" :size="size">
        <el-form-item label="">
          <el-input
            v-model="filterForm.carLicensePlateNo"
            placeholder="请输入车牌号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input
            v-model="filterForm.waybillNo"
            placeholder="请输入运单id"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input
            v-model="filterForm.driverPhone"
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input
            v-model="filterForm.driverIdCard"
            placeholder="身份证号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filterForm.status" placeholder="状态">
            <el-option 
              v-for="item in statusList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select
            v-model="filterForm.purchaseName"
            placeholder="请输入采购方名称"
            filterable clearable>
            <el-option
              v-for="item in purchaseList"
              :key="item.code"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-date-picker
            v-model="filterForm.createTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            type="primary"
            @click="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="handleReset"
            type="primary"
          />
        </el-form-item>
      </el-form>
    </div>
    <!--表格树内容栏-->
    <el-table
      :data="recordList"
      stripe
      size="mini"
      style="width: 100%"
      row-key="id"
    >
      <el-table-column
        type="index"
        width="50"
        align="center"
        fixed
        label="序号"
      >
      </el-table-column>
      <el-table-column
        prop="carLicensePlateNo"
        align="center"
        width="100"
        label="车牌号"
      >
      </el-table-column>
      <el-table-column
        prop="waybillNo"
        align="center"
        width="200"
        label="运单id"
      >
      </el-table-column>
      <el-table-column
        prop="purchaseName"
        align="center"
        label="采购方"
      >
      </el-table-column>
      <el-table-column
        prop="driverName"
        align="center"
        width="100"
        label="司机姓名"
      >
      </el-table-column>
      <el-table-column
        prop="driverPhone"
        align="center"
        width="120"
        label="司机手机号"
      >
      </el-table-column>
      <el-table-column
        prop="driverIdCard"
        align="center"
        width="150"
        label="身份证号"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        align="center"
        width="180"
        label="时间"
      >
      </el-table-column>
      <el-table-column
        align="center"
        width="80"
        label="状态"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.status == 1 ? "已入场" : "已出场" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        align="center"
        width="180"
        label="备注"
      >
      </el-table-column>
      <el-table-column
        align="center"
        width="120"
        label="操作类型"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.operationType == 1 ? "自动" : "手动" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createUser"
        align="center"
        width="100"
        fixed="right"
        label="操作人"
      >
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding: 20px">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float: right"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";
export default {
  components: {
    KtButton,
  },
  props: {
    flowDetailParams: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      filterTime: [],
      recordList: [],
      purchaseList: [],
      statusList: [
        {
          name: '已入场',
          code: 1
        },
        {
          name: '已出场',
          code: 2
        }
      ],
      filterForm: {},
    };
  },
  mounted() {
    this.getAllPurchaseList();
    this.getCarInOutRecord();
  },
  methods: {
    // 返回
    getReturn() {
      this.$emit("flowBackFun", false);
    },
    // 获取记录列表
    async getCarInOutRecord() {
      let params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          parkNo: this.flowDetailParams.parkNo,
          coalMineNo: this.flowDetailParams.coalMineNo
      }
      let index = 0
      for (let key in this.filterForm) {
          const val = this.filterForm[key]
          if (val && val !== '') {
              params['searchFieldList[' + index + '].fieldName'] = key
              if (key === 'createTime') {
                  params['searchFieldList[' + index + '].rangeMinValue'] = val[0]
                  params['searchFieldList[' + index + '].rangeMaxValue'] = val[1]
              } else {
                  params['searchFieldList[' + index + '].singleValue'] = val
              }
              index++
          }
      }
      let res = await this.$api.park.mGetEnterOutRecord(params);
      this.totalSize = res.data.totalSize;
      if (res.data && res.data.dtoList && res.data.dtoList.length > 0) {
        this.recordList = res.data.dtoList;
      } else {
        this.recordList = [];
      }
    },

    // 获取采购方列表
    async getAllPurchaseList() {
      let res = await this.$api.purchaser.mGetEjyAllPurchaseList()
      if (res.data && res.data.length > 0) {
        this.purchaseList = res.data.filter(item => item.name)
      } else {
        this.purchaseList = [];
      }
    },

    // 换页刷新和搜索
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getCarInOutRecord();
    },

    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getCarInOutRecord();
    },

    // 重置
    handleReset() {
      this.filterForm = {};
      this.getCarInOutRecord();
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}
.dialogDesc{
  text-align: center;
  font-weight: 600;
}
</style>